module Meevo.Plugins.ClientClientType {
  "use strict";

  /**
  * Main Section of Visit Note Type 
  */
  export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.ClientClientType> {

   /**
   * Base class override which defines what a DEFAULT model looks like. 
   */
      public missingField: any = -1;

      indicatorChange() {
          if (!this.model.showVisualIndicator) {
              this.model.color = null;
          }
      }

      indicatorStyle() {
          if (this.model) {
              if (this.model.color) {
                  return {
                      'fill': this.model.color
                  };
              }
              else {
                  if (this.model.showVisualIndicator) {
                      this.model.color = '#8E24AA';
                      return {
                          'fill': '#8E24AA'
                      };
                  }
              }
          }
     }

    createSectionModelInstance(postAdd:(data:any)=>any): void {
      this.dataService.getTemplate(this.baseEndpoint).then((data) => {
        this.model = data;
      });
    }

    beforeSetFocusOnField() {
        var that = this;
        setTimeout(function () { that.setFocusOnField(that.missingField) }, 400);
    }

    setFocusOnField(field: any) {
        switch (field) {
            default:
                $('#displayName input').focus();
                break;
        }
    }
  }

}